import React, { useState } from 'react';

function Develop() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  

  return (
    <section id="dev" className="dev-section">
      <h2 class="section-title">Разработка программного обеспечения</h2>
      <div className="accordion">
        <p className='component-base'> Мы создаем мощное, удобное и масштабируемое программное обеспечение, которое автоматизирует процессы, снижает нагрузку на аппаратный комплекс и обеспечивает высокое качество управления процессами.</p>
        <ul>
          <li>Веб-разработка – корпоративные сайты, интернет-магазины, веб-приложения</li>
          <li>Мобильные приложения – iOS и Android с продуманным UX/UI</li>
          <li>Настольные приложения – удобные программы для Windows</li>
          <li>Индивидуальные решения – CRM, ERP, системы аналитики и автоматизации</li>
          <li>Доработка и поддержка – улучшение, оптимизация и сопровождение ПО</li>
        </ul>
      </div>
    </section>
  );
}

export default Develop;

